import { render, staticRenderFns } from "./DefaultReplySettingsModal.vue?vue&type=template&id=160d6c1a&"
import script from "./DefaultReplySettingsModal.vue?vue&type=script&lang=js&"
export * from "./DefaultReplySettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports